var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"press"},[_c('transition',{attrs:{"name":"pagefade"},on:{"after-leave":function($event){return _vm.$root.$emit('afterRouteLeave')}}},[_c('router-view',{key:_vm.$route.path})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }